<script>
export default {
  name: 'UlFormItemPrice',
  props: {
    module: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
    },
  },
  methods: {
    submit() {
      this.$refs.input.elInput.blur();
      this.$emit('submit');
    },
    input($event) {
      this.module.value = $event;
      this.$emit('input', $event);
    },
  },
  computed: {
    currencyLabel() {
      return this.currency?.iso
        || this.currency?.label
        || this.currency
        || this.module?.currency?.iso
        || this.module?.currency?.label
        || this.module?.currency
        || '';
    },
  },
};
</script>
<template>
  <UlFormPrice
    ref="input"
    :value="module.value"
    :disabled="module.disabled"
    :min="module.min"
    :max="module.max"
    :scale="module.scale"
    :currency="currencyLabel"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="input"
    @change="$emit('change', $event)"
    @submit="submit"
  />
</template>
